var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.imageSrc != null)?_c('img',{staticClass:"content-image",attrs:{"src":_vm.imageSrc}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }